// Servicio del módulo de Despacho de Combustible.
// Cubre el portal de despacho (alta de cargas) y las pantallas de configuración
// (lugares, cisternas, tipos de combustible).
import apiClient from './apiClient';

const unwrap = (r) => r.data;
// Las listas pueden venir paginadas ({results: [...]}) o como array plano.
const listaDe = (data) => (Array.isArray(data) ? data : (data?.results || []));

const despachoCombustibleService = {
  // ─── Catálogos para los selects del formulario ──────────────────────────────
  getLugares: (params = {}) =>
    apiClient.get('lugares-despacho/', { params }).then((r) => listaDe(r.data)),

  getCisternas: (params = {}) =>
    apiClient.get('cisternas-despacho/', { params }).then((r) => listaDe(r.data)),

  getTiposCombustible: (params = {}) =>
    apiClient.get('tipos-combustible/', { params }).then((r) => listaDe(r.data)),

  getCentrosCosto: (params = {}) =>
    apiClient.get('centroscosto/', { params }).then((r) => listaDe(r.data)),

  // ─── Equipos (buscador paginado + datos para autocompletar) ─────────────────
  // Devuelve la respuesta cruda (con `results`/`next`) para alimentar el scroll
  // infinito de SearchableCombo, igual que en el resto del sistema.
  buscarEquiposPaginado: ({ search = '', page = 1, pageSize = 20 } = {}) =>
    apiClient.get('equipos/', {
      params: { ...(search ? { search } : {}), page, page_size: pageSize, baja: false, ordering: 'interno' },
    }).then((r) => r.data),

  // Trae contador y centro de costo por defecto del equipo. Acepta {equipo} o {interno}.
  getDatosEquipo: (params) =>
    apiClient.get('despachos-combustible/datos-equipo/', { params }).then(unwrap),

  // ─── Despachos ──────────────────────────────────────────────────────────────
  crearDespacho: (data) =>
    apiClient.post('despachos-combustible/', data).then(unwrap),

  listarDespachos: (params = {}) =>
    apiClient.get('despachos-combustible/', { params }).then((r) => r.data),

  actualizarDespacho: (id, data) =>
    apiClient.put(`despachos-combustible/${id}/`, data).then(unwrap),

  eliminarDespacho: (id) =>
    apiClient.delete(`despachos-combustible/${id}/`),

  // ─── CRUD de configuración ──────────────────────────────────────────────────
  crearLugar: (data) => apiClient.post('lugares-despacho/', data).then(unwrap),
  actualizarLugar: (id, data) => apiClient.put(`lugares-despacho/${id}/`, data).then(unwrap),
  eliminarLugar: (id) => apiClient.delete(`lugares-despacho/${id}/`),

  crearCisterna: (data) => apiClient.post('cisternas-despacho/', data).then(unwrap),
  actualizarCisterna: (id, data) => apiClient.put(`cisternas-despacho/${id}/`, data).then(unwrap),
  eliminarCisterna: (id) => apiClient.delete(`cisternas-despacho/${id}/`),

  crearTipoCombustible: (data) => apiClient.post('tipos-combustible/', data).then(unwrap),
  actualizarTipoCombustible: (id, data) => apiClient.put(`tipos-combustible/${id}/`, data).then(unwrap),
  eliminarTipoCombustible: (id) => apiClient.delete(`tipos-combustible/${id}/`),
};

// Extrae el identificador de equipo de un valor de QR. El QR codifica una URL
// que termina en `/qr/<valor>` — el id entero de las etiquetas de siempre, o
// el qr_token opaco (UUID) de las etiquetas impresas desde que existe el modo
// de portal QR restringido (ver QrLabel.jsx). También acepta el valor crudo,
// sin URL alrededor, en cualquiera de los dos formatos.
export function parseEquipoIdDesdeQR(valor) {
  if (!valor) return null;
  const texto = String(valor).trim();
  const match = texto.match(/\/qr\/([^/?#]+)/);
  if (match) return match[1];
  if (/^\d+$/.test(texto)) return texto;
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(texto)) return texto;
  return null;
}

export default despachoCombustibleService;
